import { http } from '../../http';
import {
    RequestDeleteScheduleCoachJob,
    RequestPostScheduleCoachJob,
    RequestPutScheduleCoachJob,
    ResponseGetScheduledCoachJobs,
} from './types';

export const postScheduleCoachJob = async (request: RequestPostScheduleCoachJob) => {
    return await http
        .post('/coaching-forms/schedule-coach-job', request)
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error scheduling coaching job:', error);
            throw error;
        });
};

export const putScheduledCoachJob = async (request: RequestPutScheduleCoachJob) => {
    return await http
        .put(`/coaching-forms/scheduled-coach-jobs/${request.coachJobId}`, request)
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error updating scheduled coaching job:', error);
            throw error;
        });
};
export const getScheduledCoachJobs = async () => {
    return await http
        .get<ResponseGetScheduledCoachJobs>('/coaching-forms/scheduled-coach-jobs')
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error fetching scheduled coaching jobs:', error);
            throw error;
        });
};

export const deleteScheduleCoachJob = async ({ coachJobId }: RequestDeleteScheduleCoachJob) => {
    return await http
        .delete(`/coaching-forms/scheduled-coach-jobs/${coachJobId}`)
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error deleting scheduled coaching job:', error);
            throw error;
        });
};
